import axios from "axios";
import { store } from "../../redux/store";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const AuthAPI = {
  login: async (params) => {
    const result = await axiosInstance.post("/login", params);

    return result.data;
  },
  register: async (params) => {
    const result = await axiosInstance.post("/client/users", params);

    return result.data;
  },
  refresh: async () => {
    const { refreshToken } = store.getState().authDetails;

    axiosInstance.defaults.headers.common.Authorization = `Bearer ${refreshToken}`;

    const result = await axiosInstance.post("/refresh");

    return result.data;
  },
  logout: async () => {
    const { accessToken } = store.getState().authDetails;

    axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    await axiosInstance.post("/logout");
  },
  getResetPasswordLink: async (params) => {
    const result = await axiosInstance.get("/client/users/passwordreset", {
      params,
    });

    return result.data;
  },
  resetPassword: async (token, params) => {
    const result = await axiosInstance.post(
      `/users/passwordreset/${token}`,
      params
    );

    return result.data;
  },
  verifyAccount: async (token) => {
    const result = await axiosInstance.post(`/users/verify/${token}`);

    return result.data;
  },
};
